



















import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import {QueryPurchaseReceiptDetail} from '../../../api/shipmentsManagement'
@Component({
    components:{myTable}
})
export default class extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    list:any = []
    created(){
        this.getData()
    }
    //
    async getData(){
        let res = await QueryPurchaseReceiptDetail({PurPurchaseReceiptId:this.data.purPurchaseReceiptId})
        this.list = res.data
    }
    columns:Array<object> = [
        {title:'采购单号',key:'receiptNo'},
        {title:'物资名称',key:'itemName'},
        {title:'采购数量',key:'quantity'},
        {title:'供货商',key:'supplierName'},
        {title:'批号',key:'batchNo'},
        {title:'有效期',key:'expireDate'},
        {title:'采购人',key:'originatorName'},
    ]
    cancel(){
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}
